export default __webpack_public_path__ + "static/media/mariog10.03ac9f2f.jpg";